export default "<p>Redirecting...</p>\r\n";